import { PackageStateType } from '~shared/types/pricing/state';
import { grow2529State } from '~app/pages/Pricing/experiments/grow_2529_forms/reducer';
import { grow2792State } from '~app/pages/Pricing/experiments/grow_2792_pnp_refresh_v1/reducer';

export const packageState: PackageStateType = {
  allPackages: [],
  displayPackages: [],
  packagesToDisplayState: [],
};

export const combinedStates = {
  packages: packageState,
  grow2529: grow2529State,
  grow2792: grow2792State,
};
